<template>
  <section
    class="page__section"
    :style="sectionStyle"
  >
    <div class="container">
      <div
        class="editor editor__content editor__page margin__b--36"
        v-if="translate(text)"
        v-html="translate(text)"
      />

      <app-counter
        :metrics="metrics"
        :query="query"
      />
    </div>
  </section>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { useSectionStyle } from '@/composables/modules/pages'

const AppCounter = defineAsyncComponent(() => import('@/components/molecules/AppCounter'))

const { section } = defineProps({
  section: { type: Object, required: true }
})

const { translate } = useI18n()
const { sectionStyle } = useSectionStyle(section)

const { text, metrics = [], query = {} } = section.attributes
</script>

<style lang="scss" scoped>
:deep() {
  .counter {
    &__ul {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 24px;
      justify-items: center;
      align-items: baseline;
      text-align: center;

      @include mq(md) {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      }
    }

    &__value {
      font-size: rem(28px);
      font-weight: bold;
      text-align: center;
      white-space: nowrap;

      @include mq(md) {
        font-size: rem(40px);
      }
    }

    &__text {
      font-size: rem(16px);
      text-align: center;
      margin-top: calc(6px);

      @include mq(md) {
        font-size: rem(20px);
      }
    }
  }
}
</style>
